module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "board-header"
  }, [(_vm.item.un_pin_class === 2) ? _c('div', {
    staticClass: "unpin"
  }, [_c('i', {
    staticClass: "fa fa-star"
  })]) : _vm._e(), (_vm.item.classes.private) ? _c('div', {
    staticClass: "private-lock"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })]) : _vm._e(), (_vm.$isMobile()) ? _c('div', {
    ref: "boxPopover",
    staticClass: "board-header-function",
    class: [(_vm.keyActiveClass === 'itemClass_' + _vm.item.classes_id && _vm.isPopoverClass) ? 'open-popover' : ''],
    on: {
      "click": function($event) {
        return _vm.clickPopoverClass('itemClass_' + _vm.item.classes_id, _vm.item.classes_id)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons text-gray",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("more_horiz")]), _c('div', {
    ref: "popoverID",
    staticClass: "box-popover",
    class: [_vm.keyActiveClass === 'itemClass_' + _vm.item.classes_id && (_vm.isSmart === 4 ? 'limit-right-bottom' : (_vm.isSmart === 1 ? 'limit-right' : (_vm.isSmart === 2) ? 'limit-bottom' : ''))],
    attrs: {
      "id": 'popoverID_' + _vm.item.classes_id
    }
  }, [(_vm.item.status === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onFlagDeleted(_vm.item)
      }
    }
  }, [_vm._v("Xoá yêu cầu")]) : _vm._e(), (_vm.item.status === 3) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item)
      }
    }
  }, [_vm._v("Xoá yêu cầu")]) : _vm._e(), (_vm.item.status === 2 && _vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e(), (_vm.item.status === 2 && _vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 1)
      }
    }
  }, [_vm._v("Bỏ ghim lớp học")]) : _vm._e(), (_vm.item.status === 2 && _vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.copyLinkJoin(_vm.item)
      }
    }
  }, [_vm._v("Copy link tham gia")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 1)
      }
    }
  }, [_vm._v("Bỏ ghim lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.copyLinkJoin(_vm.item)
      }
    }
  }, [_vm._v("Copy link tham gia")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 2)
      }
    }
  }, [_vm._v("Ghim lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e()])]) : _c('div', {
    ref: "boxPopover",
    staticClass: "board-header-function and-hover",
    on: {
      "mouseleave": function($event) {
        return _vm.clickPopoverClass('itemClass_' + _vm.item.classes_id, _vm.item.classes_id)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons text-gray",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("more_horiz")]), _c('div', {
    ref: "popoverID",
    staticClass: "box-popover",
    class: [_vm.keyActiveClass === 'itemClass_' + _vm.item.classes_id && (_vm.isSmart === 4 ? 'limit-right-bottom' : (_vm.isSmart === 1 ? 'limit-right' : (_vm.isSmart === 2) ? 'limit-bottom' : ''))],
    attrs: {
      "id": 'popoverID_' + _vm.item.classes_id
    }
  }, [(_vm.item.status === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onFlagDeleted(_vm.item)
      }
    }
  }, [_vm._v("Xoá yêu cầu")]) : _vm._e(), (_vm.item.status === 3) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item)
      }
    }
  }, [_vm._v("Xoá yêu cầu")]) : _vm._e(), (_vm.item.status === 2 && _vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e(), (_vm.item.status === 2 && _vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 1)
      }
    }
  }, [_vm._v("Bỏ ghim lớp học")]) : _vm._e(), (_vm.item.status === 2 && _vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.copyLinkJoin(_vm.item)
      }
    }
  }, [_vm._v("Copy link tham gia")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 1)
      }
    }
  }, [_vm._v("Bỏ ghim lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 2) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.copyLinkJoin(_vm.item)
      }
    }
  }, [_vm._v("Copy link tham gia")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.unPinPC(_vm.item, 2)
      }
    }
  }, [_vm._v("Ghim lớp học")]) : _vm._e(), (_vm.item.status === 2 && !_vm.item.classes.private && _vm.item.un_pin_class === 1) ? _c('span', {
    on: {
      "click": function($event) {
        return _vm.onDeleted(_vm.item, false)
      }
    }
  }, [_vm._v("Rời lớp học")]) : _vm._e()])]), _c('div', {
    staticClass: "clearfix"
  })]), _c('router-link', {
    attrs: {
      "to": {
        name: 'classes_to_me_detail',
        query: {
          id: _vm.item.classes_id
        },
        params: {
          reload: 1
        }
      }
    }
  }, [_c('div', {
    staticClass: "board-img"
  }, [(_vm.item.classes.thumbnail !== undefined && _vm.item.classes.thumbnail !== null && _vm.item.classes.thumbnail.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.item.classes.thumbnail
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_AvatarDefault@2x.png")
    }
  }), (_vm.item.status === 1 || _vm.item.status === 3) ? _c('div', {
    staticClass: "status-img"
  }, [(_vm.item.status === 1) ? _c('span', {
    staticClass: "approval"
  }, [_vm._v("Chờ duyệt")]) : (_vm.item.status === 3) ? _c('span', {
    staticClass: "cancel"
  }, [_vm._v("Bị từ chối")]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "board-info"
  }, [_c('div', {
    staticClass: "title-classes"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.classes.name))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24403004","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassesMe/itemClasses.vue
// module id = 1514
// module chunks = 0